import React, { useEffect, useState }           from 'react'
import axios                                    from 'axios'
import Box                                      from '@material-ui/core/Box'
import { CLIENT_PUBLIC_TOKEN }                  from '../config'
import {
   getEntry,
   node_server
 }                                              from '../Helpers/index.js'
import Grid                                     from '@material-ui/core/Grid'
import GuestBioSearchComponent                  from './GuestBioSearchComponent'
import GuestBioHistoryEntryReadComponent        from './GuestBioHistoryEntryReadComponent'
import Typography                               from '@material-ui/core/Typography'

const GuestBioUpdateComponent = () => {

   const [ guestBio,                            setGuestBio                      ]  =  useState({})
   /* id here is the overall id of the item from the MongoDB collection */
   const [ id,                                  setId                            ]  =  useState('')
   /* This is the _id of the selected row from the Table */
   const [ subEntryId,                          setSubEntryId                    ]  =  useState('')

   const handleClickGuestBio = (guestBioId) => {
      setId(guestBioId._id)
   }

   /* 2. This then gets that object from the MongoDB collection */
   useEffect( () => {
      console.log('Guest Bio Update Component useEffect is running')
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      if (id !== '') {
         axios.get(node_server + `guestBio/${id}`)
            .then( res => res.data )
            .then( data => {
               if (data.msg === 'good_operation') {
                  setGuestBio(data.guestBio)
               }
               else {
                  throw new Error('bad_operation_get_gb2')
               }
            } )
            .catch( (error) => {
               console.error(error)
            } )
      }
   }, [id] )

   return(
      <Box style={{ marginTop: '6rem', marginBottom: '1rem', padding: '2rem' }} >
         <Grid>
            <Typography variant='h4'>
               Guest Bio Update Page
            </Typography>
         </Grid>
         <Grid>
            {/*           1. This returns the _id of the collection object from MongoDB               3. This then displays the object from MongoDB */}
            { id === '' ? <GuestBioSearchComponent handleClickGuestBio={handleClickGuestBio} /> :   <GuestBioHistoryEntryReadComponent entry={guestBio} /> }
         </Grid>
      </Box>
   )
}

export default GuestBioUpdateComponent
